import React from 'react';
import { StripeProvider, Elements } from 'react-stripe-elements';
import CheckoutForm from './CheckoutForm'

class Step2 extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <React.Fragment>
        <StripeProvider apiKey={this.props.stripe_key}>
          <Elements>
            <CheckoutForm {...this.props} />
          </Elements>
        </StripeProvider>
      </React.Fragment>
    )
  }
}

export default Step2
